interface User {
  id: number;
  name: string;
}

interface UserPreviewState {
  query: string;
  users: User[];
  selectedUser: null | User;
  showResults: boolean;
  searchUsers: () => Promise<void>;
  activatePreview: () => Promise<void>;
  selectUser: (user: User) => void;
}

function alpineData() {
  return {
    query: "",
    users: [],
    selectedUser: null,
    showResults: false,

    async searchUsers() {
      const response = await fetch(`/api/private/users/search?q=${encodeURIComponent(this.query)}`);
      this.users = await response.json();
      this.showResults = true;
    },

    async activatePreview() {
      if (!this.selectedUser) return;

      const csrfToken =
        document.querySelector("meta[name='csrf-token']")?.getAttribute("content") ?? "";

      const res = await fetch(`/user_preview/${this.selectedUser.id}`, {
        method: "POST",
        headers: {
          "x-csrf-token": csrfToken,
          "content-type": "application/json",
        },
        credentials: "same-origin",
      });

      if (res.redirected) {
        window.location.href = res.url;
      }
    },

    selectUser(user: User) {
      this.selectedUser = user;
      this.query = user.name;
      this.showResults = false;
    },
  } as UserPreviewState;
}

export default alpineData;
